import { faArchive, faBookOpen, faCopy, faPen, faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, withStyles } from '@material-ui/core';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { WarningIconWithTooltip } from '../../../common-client2/src/components';
import Tooltip from '../../../common/components/UI/ToolTip/ToolTip';
import { isEdge, isIE } from '../../../common/utilities/browserDetection';
import { getRequestTypeLabel } from '../../Enums/Helpers/LabellingHelper';
import React from 'react';

import {
	Buttons, ItemTitle, RowItem, styles,
} from './tableRow.service';

import './tableRow.scss';

class SettingRow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showButtons: false
		};
	}

	showButtonsHandler = (state) => {
		this.setState({ showButtons: state })
	}

	dotsContainer = () => {
		return <div></div>
	}

	buttonsHandler = (e, action) => {
		e.stopPropagation();
		this.props.showRightPanel(action, this.props.item)
	}

	buttonsContainer = (classes) => {
		const { t, item, isArchive = false } = this.props;
		const { isDeletable } = item;

		return (
			<Buttons>
				{isArchive
					? (
						<Button
							className={classes.buttonsAction}
							onClick={(e) => { this.buttonsHandler(e, t('settings.view')) }}>
							<FontAwesomeIcon
								className={classes.fontAwesomeIcon}
								icon={faBookOpen} />
							{t('settings.view')}
						</Button>
					)
					: (
						<Button
							className={classes.buttonsAction}
							onClick={(e) => { this.buttonsHandler(e, t('settings.edit')) }}>
							<FontAwesomeIcon
								className={classes.fontAwesomeIcon}
								icon={faPen} />
							{t('settings.edit')}
						</Button>
					)}
				<Button
					className={classes.buttonsAction}
					onClick={(e) => { this.buttonsHandler(e, t('settings.duplicate')) }}>
					<FontAwesomeIcon
						className={classes.fontAwesomeIcon}
						icon={faCopy} />
					{t('settings.duplicate')}
				</Button>
				{!isArchive && (
					<>
						{isDeletable && <Button
							className={classes.buttonsAction}
							onClick={(e) => { this.buttonsHandler(e, t('settings.delete')) }}>
							<FontAwesomeIcon
								className={classes.fontAwesomeIcon}
								icon={faTrash} />
							{t('settings.delete')}
						</Button>}
						<Button
							className={classes.buttonsAction}
							onClick={(e) => { this.buttonsHandler(e, t('settings.archive')) }}>
							<FontAwesomeIcon
								className={classes.fontAwesomeIcon}
								icon={faArchive} />
							{t('settings.archive')}
						</Button>
					</>
				)}
			</Buttons>)
	}

	getHyperfindLabel = (hyperfindSettings) => {
		const { hyperFindList, item, t } = this.props;
		let auxLabel = ''
		if (hyperfindSettings.length > 1) {
			auxLabel = <Tooltip
				titleText={
					item.hyperfindSettings.map(config => {
						let hyperfind = this.props.hyperFindList.find(hf => hf.value === config.hyperfindId)
						if (hyperfind)
							return <div>{hyperfind.label}</div>
						return null
					}, this)
				}
				jsx={<span>{t('form.multipleHyperfindsSelected')}</span>} />
		} else {
			auxLabel = hyperFindList.find(hyperfind => hyperfind.value === hyperfindSettings[0].hyperfindId)?.label
		}

		return auxLabel ? auxLabel : hyperfindSettings[0].hyperfindId

	}

	render() {
		const { classes, item, index, t } = this.props;
		const buttonsSection = !this.state.showButtons ? this.dotsContainer() : this.buttonsContainer(classes);
		const description = (item.description.length > 30) ? item.description.substring(0, 27) + "..." : item.description;

		const warnings = [
			...new Set(
			  item?.hyperfindSettings?.flatMap(x =>
				x.warnings?.map(x => t(`manager.managerWarnings.${x}`))
			  )
			),
		  ];
		  
		return (
			<RowItem
				index={index}
				className={classes?.quotaItemStyling}
				onMouseOver={() => { this.showButtonsHandler(true) }}
				onMouseLeave={() => { this.showButtonsHandler(false) }}>
				<ItemTitle className={classes?.name}>
					<div className={classes?.namefontWeigth}>{item.name}</div>
				</ItemTitle> 
				<ItemTitle className={classes?.warning}>
					{warnings?.length > 0 && <WarningIconWithTooltip tooltipWarnings={warnings} />}
				</ItemTitle>
				<ItemTitle className={classes?.description}>
					{description}
				</ItemTitle>
				<ItemTitle className={classes?.requestType}>
					{getRequestTypeLabel(item.type)}
				</ItemTitle>
				<ItemTitle className={classes?.approvalProcess}>
					{item.approvalProcessLabel}
				</ItemTitle>
				<ItemTitle className={classes?.submissionPeriod}>
					<span className="periodWrapper">
						{item.submissionPeriodLabel}
					</span>
				</ItemTitle>
				<ItemTitle className={classes?.requestPeriod}>
					<span className="periodWrapper">
						{item.requestPeriodLabel}
					</span>
				</ItemTitle>
				<ItemTitle className={classes?.hyperFindQuery}>
					{this.getHyperfindLabel(item.hyperfindSettings)}
				</ItemTitle>
				<ItemTitle className={classes?.setup}>
				<span className="setupWrapper">
					{[...new Set(item.setupLabels)].map((label, index) => (
						<span key={index}>
							{index > 0 && ' • '}{label}
						</span>
					))}
				</span>
				</ItemTitle>
				<div className={[classes?.buttonSection, (isIE() || isEdge()) ? classes?.adjustment : ''].join(' ')}>
					{buttonsSection}
				</div>
			</RowItem>
		)
	}
}

export default withTranslation('employmentBillboard')(withStyles(styles)(SettingRow));